/**
 * Tooltip Portal Extension
 *
 * Renders CodeMirror tooltips at the document body level to escape
 * stacking context issues with parent containers.
 */

import { Extension } from "@codemirror/state";
import { tooltips } from "@codemirror/view";

/**
 * Extension that renders tooltips at document body level
 */
export const tooltipPortal: Extension = tooltips({
  parent: document.body
});
